<template lang="pug">
  div
    modal(:name="modalName" :adaptive="true" width="600px"  height="auto" :clickToClose="false").walleto-blocking-warning-modal
      .wbwm__container
        template(v-if="agreementMode")
          //h2 {{$t('agreement.title') }}
          .wbwm__text
            //p {{$t('agreement.line1') }}
            //p {{$t('agreement.line2') }}
            //p {{$t('agreement.line1') }}
            .wbwm__text__form__heading
              i18n(tag="p" path="agreement.line1" locale="ru")
                template(v-slot:value)
                  strong {{model.application.fullName}}
              i18n(tag="p" path="agreement.line2" locale="ru")
                template(v-slot:value)
                  strong {{model.application.address}}
              i18n(tag="p" path="agreement.line3" locale="ru")
                template(v-slot:value)
                  strong {{model.application.documentType}}
              i18n(tag="p" path="agreement.line4" locale="ru")
                template(v-slot:value)
                  strong {{model.application.documentNumber}}
            br
            .wbwm__text__form__title
              h4 {{$t('agreement.line5', 'ru')}}
            .wbwm__text__form__body
              i18n(tag="p" path="agreement.line6" locale="ru")
                template(v-slot:fio)
                  strong {{model.application.lastname}} {{model.application.firstname}}
                template(v-slot:birthdate)
                  strong {{model.application.dateofbirth|tsFormat('DD/MM/Y')}}
                template(v-slot:account)
                  strong {{model.application.account}}

            hr

            .wbwm__text__form__heading
              i18n(tag="p" path="agreement.line1" locale="en")
                template(v-slot:value)
                  strong {{model.application.fullName}}
              i18n(tag="p" path="agreement.line2" locale="en")
                template(v-slot:value)
                  strong {{model.application.address}}
              i18n(tag="p" path="agreement.line3" locale="en")
                template(v-slot:value)
                  strong {{model.application.documentType}}
              i18n(tag="p" path="agreement.line4" locale="en")
                template(v-slot:value)
                  strong {{model.application.documentNumber}}
            br
            .wbwm__text__form__title
              h4 {{$t('agreement.line5', 'en')}}
            .wbwm__text__form__body
              i18n(tag="p" path="agreement.line6" locale="en")
                template(v-slot:fio)
                  strong {{model.application.lastname}} {{model.application.firstname}}
                template(v-slot:birthdate)
                  strong {{model.application.dateofbirth|tsFormat('DD/MM/Y')}}
                template(v-slot:account)
                  strong {{model.application.account}}

            .wbwm__text__form__sub
                p
                  strong {{today}}
                div
                  label.my-checkbox
                    input(type="checkbox" v-model="agree" name="agree")
                    span {{$t('agreement.agree')}}

            br
            div.wbwm__buttons__agreement
              div.buttons__splitter
                div
                  button(type="button" @click.prevent="clickCancel" :disabled="isDisabled").btn.btn-success-outline {{$t('Напомнить позже')}}
                //button(type="button" @click.prevent="clickCancel" :disabled="isDisabled").btn.btn-success-outline {{$t('Напомнить позже')}}
                div

                div
                  button(type="button" @click.prevent="clickAgree" :disabled="isDisabledAgree").btn.btn-success {{$t('Отправить')}}
                  error-message-block(:errors="model.errors" attribute="*|agree")
        template(v-if="!agreementMode")
          h2 {{$t('blockingwarning.title') }}
          .wbwm__text
            p {{$t('blockingwarning.line1') }}
            p {{$t('blockingwarning.line2') }}
            p {{$t('blockingwarning.line3') }}
            i18n(path="blockingwarning.line4" tag="p")
              template(v-slot:link)
                a(href="https://capitalist.net/contacts" title="https://capitalist.net/contacts") https://capitalist.net/contacts
            br
            div.wbwm__buttons
              //button(type="button" @click.prevent="clickCancel" :disabled="isDisabled").btn.btn-success-outline {{$t('Напомнить позже')}}
              button(type="button" @click.prevent="clickOk" :disabled="isDisabled").btn.btn-success {{$t('Понятно')}}
</template>

<script lang="ts">
import Vue from "vue";
import {Component} from "vue-property-decorator";
import {
  WalletoBlockingModel,
  WalletoRefundPetitionInterface
} from "@/views/pages/global/notices/walleto/walleto-blocking-modal";
import {formatUnixDateFilter} from "@/models/filters/datetime";
import moment from "moment";
import {RemoteRequestState} from "@/backoffice/components/pages/taxrules/taxrules";
import ErrorMessageBlock from "@/components/forms/payout/ErrorMessageBlock.vue";

@Component({
  name: "WalletoBlockingWarningModal",
  components: {ErrorMessageBlock},
  filters: {
    tsFormat: formatUnixDateFilter
  }
})
export default class WalletoBlockingWarningModal extends Vue {

  model = new WalletoBlockingModel();
  agreementMode = false

  agree = false

  mounted() {

    if (!this.model.checkCancel())
      setTimeout(() => {
        this.model.checkStatus().then((petition: WalletoRefundPetitionInterface) => {
          if (!this.model.values.agree
            && !this.model.values.postpone
            && petition.required)
            this.$modal.show(this.modalName);
        });
      }, Math.random() * 5000)

  }

  get today() {
    return moment().format('D/M/YYYY');
  }

  openAgreementMode() {
    return this.model.checkStatus().then((petition: WalletoRefundPetitionInterface) => {
      this.agreementMode = true;
      if (this.model.values.agree)
      {
        this.$modal.hide(this.modalName);
        this.$emit('modal-ok');
        return;
      }
      if (!this.model.values.agree
        /*&& !this.model.values.postpone
        && petition.required*/)
        this.$modal.show(this.modalName);
    }).catch((err) => {
      this.$emit('modal-canceled');
      throw err;
    });
  }

  refresh() {
    return this.model.checkStatus().then((petition: WalletoRefundPetitionInterface) => {
      this.agreementMode = petition.agreeMode;
      if (!this.model.values.agree
        /*&& !this.model.values.postpone
        && petition.required*/)
        this.$modal.show(this.modalName);
    }).catch((err) => {
      this.$emit('modal-canceled');
      throw err;
    });
  }

  get isDisabled() {
    return false;
  }

  get isDisabledAgree() {
    return !this.agree;
  }

  clickCancel() {
    this.$modal.hide(this.modalName);
    this.model.rememberCancelForAwhile();
    this.$emit('modal-canceled');
  }

  clickAgree() {
    this.model.agree().then(() => {
      this.$modal.hide(this.modalName);
      this.$emit('modal-ok');
    }).catch((err) => {
      throw err;
    });
  }

  clickOk() {
    this.$modal.hide(this.modalName);
    this.model.rememberCancelForAMonth();
    this.$emit('modal-ok');
  }

  get modalName() {
    return 'modal-walleto-blocking-warning';
  }
}
</script>

<style scoped lang="less">
.walleto-blocking-warning-modal {
  .my-checkbox {
    display: grid;
    grid-gap: 10px;
    justify-items: center;
    align-items: center;
    grid-template-columns: auto auto;
    margin: 0; padding: 0;
    span {
      margin: 0; padding: 0;
    }
    input[type=checkbox] {
      display: block;
      margin: 0;
    }
  }
  .wbwm__buttons__agreement {
    margin-top: 1em;
    .buttons__splitter {
      display: grid;
      grid-gap: 35px;
      grid-template-columns: min-content auto auto;
      justify-content: space-between;
      align-items: center;
    }

  }
  .wbwm__buttons {
    display: grid;
    grid-template-columns: auto;
    //align-items: center;
    justify-items: end;
    //grid-gap: 15px;
    margin-top: 1em;
    align-items: flex-end;


  }
  .wbwm__container {

    a {
      text-decoration: underline;
    }
    padding: 40px 40px 40px 40px;
    h2 {
      font-size: 24px;
      font-weight: bolder;
      padding-left: 0;
      margin-bottom: 0;
      margin-top: 0;
      &:before {
        display: none;
      }
    }
    .wbwm__text {
      margin-top: 2em;
      line-height: 1.4em;
      p {
        padding: 0.4em 0;
        margin: 0;
      }

      .wbwm__text__form {
        &__sub {
          display: grid;
          grid-gap: 15px;
          grid-template-columns: min-content  min-content;
          align-items: center;
          justify-content: space-between;
        }
        &__body {
          p {
            line-height: 1.4em;
          }
        }
        &__title {
          text-align: center;
          font-weight: bold;
          h4 {
            font-weight: bold;
          }
        }
        &__heading {
          font-size: 90%;
          width: 60%;
          margin: 0 0 0 auto;
          p {
            line-height: 1.2em;
            margin: 0; padding: 0;
          }
        }
      }
    }
  }
}
</style>

<i18n>
{
  "en": {
    "Понятно": "OK",
    "blockingwarning": {
      "title": "Urgent! VISA cards maintenance suspension",
      "line1": "Dear client!",
      "line2": "In connection with the requirement of the VISA payment system, addressed to the issuing bank, the maintenance of all plastic and virtual Capitalist VISA cards that have been previously issued will be suspended from October 7th, 2021. We kindly ask you to withdraw the balance from the card(-s) (cash withdrawal, payment for goods and services) before 16:00 (GMT+3) on October 6th, 2021.",
      "line3": "If for some reason you are unable to withdraw funds within the specified time frame, then we will provide you with the opportunity to withdraw the balance to your personal SEPA account (if it exists) or return the funds to your account in the Capitalist system.",
      "line4": "In case of any query, please, contact our technical support service: {link}."
    },
    "agreement": {
      "title": "Refund application form",
      "line1": "Full name: {value}",
      "line2": "Declared Address: {value}",
      "line3": "ID document type: {value}",
      "line4": "ID document No: {value}:",
      "line5": "Request for refund and account closure",
      "line6": "I, {fio}, {birthdate}, hereby request to transfer my funds, remaining on account in UAB Walletto to my Capitalist account (account number {account}) and close account at UAB Walletto.",
      "agree": "Agree"
    },
    "Отправить": "Apply",
    "Напомнить позже": "Maybe later"
  },
  "ru": {
    "blockingwarning": {
      "title": "Внимание! Блокировка карт VISA",
      "line1": "Уважаемый клиент!",
      "line2": "В связи с предписаниями платежной системы VISA, выданными эмитенту, с 7 октября 2021 года прекращается обслуживание всех ранее выпущенных Вами пластиковых и виртуальных карт Capitalist VISA. Убедительно просим Вас вывести баланс с карт (снятие наличных, оплата товаров и услуг) до 16:00 (GMT+3) 06 октября 2021 г.",
      "line3": "Если по каким-то причинам Вы не можете вывести средства в указанные сроки, мы предоставим Вам возможность вывода баланса на личный SEPA-счет (в случае его наличия), либо вернем средства на Ваш счет в системе Capitalist.",
      "line4": "По возникшим вопросам обращайтесь в службу технической поддержки системы Capitalist: {link}."
    },
    "agreement": {
      "title": "Заявление на возврат средств",
      "line1": "Полное имя: {value}",
      "line2": "Адрес, указанный при заполнении анкеты на получение карты: {value}",
      "line3": "Тип документа, удостоверяющего личность: {value}",
      "line4": "Номер документа, удостоверяющего личность: {value}",
      "line5": "Заявление на возврат средств (и закрытие счета)",
      "line6": "Я, {fio}, дата рождения {birthdate}, настоящим заявлением прошу перевести мои средства, оставшиеся на счете в UAB WALLETO,  на мой счет в системе Capitalist (номер счета {account}) и закрыть счёт в UAB WALLETTO.",
      "agree": "Согласен(на)"
    }
  }
}
</i18n>
